// src/config/sliderConfig.js

const baseSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  
  export const depoimentoSliderSettings = {
    ...baseSliderSettings,
    slidesToShow: 2,
    slidesToScroll: 2,
  };
  
  export const blogSliderSettings = {
    ...baseSliderSettings,
    slidesToShow: 3,
    slidesToScroll: 3,
  };
  